import {
  darken,
  defaultVariantColorsResolver,
  VariantColorsResolver,
} from "@mantine/core"

export const variantColorResolver: VariantColorsResolver = (input) => {
  const defaultResolvedColors = defaultVariantColorsResolver(input)

  //--------- PRIMARY VARIANT ------------ //
  if (input.variant === "primary") {
    return {
      background: "var(--mantine-color-primary-6)",
      hover: darken("var(--mantine-color-primary-6)", 0.1),
      border: "none",
      color: "var(--mantine-color-white)",
    }
  }

  //--------- PRIMARY CRITICIAL VARIANT ------------ //
  if (input.variant === "primary-critical") {
    return {
      background: "var(--mantine-color-red-6)",
      hover: "var(--mantine-color-red-7)",
      color: "var(--mantine-color-white)",
      border: "none",
    }
  }

  //--------- SECODNARy VARIANT ------------ //
  if (input.variant === "secondary") {
    return {
      background: "var(--mantine-color-primary-0)",
      hover: "var(--mantine-color-primary-1)",
      color: "var(--mantine-color-primary-6)",
      border: "1px solid var(--mantine-color-primary-6)",
    }
  }

  //--------- SECODNARy VARIANT ------------ //
  if (input.variant === "secondary-critical") {
    return {
      background: "var(--mantine-color-red-0)",
      hover: "var(--mantine-color-red-1)",
      color: "var(--mantine-color-red-6)",
      border: "var(--mantine-color-red-6)",
    }
  }

  //----------------- TERTIARY VARIANT ----------------- //
  if (input.variant === "tertiary") {
    return {
      background: "transparent",
      border: "none",
      hover: "var(--mantine-color-gray-0)",
      color: "var(--mantine-color-gray-7)",
    }
  }

  if (input.variant === "tertiary-critical") {
    return {
      background: "transparent",
      hover: "var(--mantine-color-gray-0)",
      border: "none",
      hoverColor: "var(--mantine-color-red-7)",
      color: "var(--mantine-color-red-6)",
    }
  }

  if (input.variant === "admin") {
    return {
      background: "var(--mantine-color-violet-1",
      hover: "var(--mantine-color-violet-2)",
      color: "var(--mantine-color-violet-6)",
      border: "none",
    }
  }

  if (input.variant === "admin-tertiary") {
    return {
      background: "transparent",
      hover: "var(--mantine-color-violet-0)",
      color: "var(--mantine-color-violet-6)",
      border: "none",
    }
  }

  return defaultResolvedColors
}
